// src/components/strumenti/ScadenzaPagamento.js
// Elenco delle condizioni di pagamento più comuni nella prassi commerciale italiana.
// D.F.F.M. = "Data Fattura Fine Mese" (W442, calcolo in utils/calcoliStrumenti.js): con giorni multipli
// di 30 si contano i mesi interi dalla fine del mese della fattura (26/05, 60 gg DFFM → 31/07);
// con altri giorni si aggiungono i giorni alla data fattura e si va a fine di quel mese.
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { scadenzaPagamento } from "../../utils/calcoliStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

const CONDIZIONI = [
  { id:"immediato",      label:"Immediato / a vista",        giorni:0,   dffm:false },
  { id:"15gg",           label:"15 gg data fattura",         giorni:15,  dffm:false },
  { id:"30gg",           label:"30 gg data fattura",         giorni:30,  dffm:false },
  { id:"30gg_dffm",      label:"30 gg D.F.F.M.",             giorni:30,  dffm:true },
  { id:"45gg",           label:"45 gg data fattura",         giorni:45,  dffm:false },
  { id:"45gg_dffm",      label:"45 gg D.F.F.M.",             giorni:45,  dffm:true },
  { id:"60gg",           label:"60 gg data fattura",         giorni:60,  dffm:false },
  { id:"60gg_dffm",      label:"60 gg D.F.F.M.",             giorni:60,  dffm:true },
  { id:"75gg",           label:"75 gg data fattura",         giorni:75,  dffm:false },
  { id:"75gg_dffm",      label:"75 gg D.F.F.M.",             giorni:75,  dffm:true },
  { id:"90gg",           label:"90 gg data fattura",         giorni:90,  dffm:false },
  { id:"90gg_dffm",      label:"90 gg D.F.F.M.",             giorni:90,  dffm:true },
  { id:"120gg",          label:"120 gg data fattura",        giorni:120, dffm:false },
  { id:"120gg_dffm",     label:"120 gg D.F.F.M.",            giorni:120, dffm:true },
  { id:"fine_mese",      label:"Fine mese (0 gg D.F.F.M.)",  giorni:0,   dffm:true },
  { id:"personalizzato", label:"Personalizzato...",          giorni:null, dffm:false },
];

export default function ScadenzaPagamento() {
  const [condizioneId, setCondizioneId] = useState("30gg");
  const [dataFattura, setDataFattura] = useState("");
  const [giorniCustom, setGiorniCustom] = useState("30");
  const [dffmCustom, setDffmCustom] = useState(false);

  const condizione = CONDIZIONI.find(c => c.id === condizioneId);
  const personalizzato = condizioneId === "personalizzato";
  const giorni = personalizzato ? (parseInt(giorniCustom)||0) : condizione.giorni;
  const usaDFFM = personalizzato ? dffmCustom : condizione.dffm;

  const scadenza = scadenzaPagamento(dataFattura, giorni, usaDFFM);

  const formatData = d => d ? d.toLocaleDateString("it-IT",{weekday:"long",day:"numeric",month:"long",year:"numeric"}) : "—";

  return (
    <div>
      <div style={{ marginBottom:12 }}>
        <label style={lbl}>Condizione di pagamento</label>
        <select value={condizioneId} onChange={e=>setCondizioneId(e.target.value)} style={inp}>
          {CONDIZIONI.map(c => <option key={c.id} value={c.id}>{c.label}</option>)}
        </select>
      </div>

      {personalizzato && (
        <div style={{ display:"flex", gap:12, marginBottom:12, alignItems:"flex-end" }}>
          <div style={{ flex:1 }}>
            <label style={lbl}>Giorni</label>
            <input value={giorniCustom} onChange={e=>setGiorniCustom(e.target.value)} style={inp}/>
          </div>
          <label style={{ display:"flex", alignItems:"center", gap:6, paddingBottom:10, cursor:"pointer", whiteSpace:"nowrap" }}>
            <input type="checkbox" checked={dffmCustom} onChange={e=>setDffmCustom(e.target.checked)} style={{ accentColor:"#059669" }}/>
            <span style={{ fontSize:12, color:"#374151" }}>D.F.F.M. (da fine mese)</span>
          </label>
        </div>
      )}

      <div style={{ marginBottom:16 }}>
        <label style={lbl}>Data fattura</label>
        <input type="date" value={dataFattura} onChange={e=>setDataFattura(e.target.value)} style={inp}/>
      </div>

      <div style={{ background:"#ecfdf5", border:"1px solid #a7f3d0", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Data di scadenza</div>
        <div style={{ fontSize:17, fontWeight:800, color:"#059669", textTransform:"capitalize" }}>
          {formatData(scadenza)}
        </div>
      </div>

      {usaDFFM && (
        <div style={{ fontSize:10.5, color:"#6b7280", marginTop:8, lineHeight:1.5 }}>
          D.F.F.M.: {giorni % 30 === 0 ? `${giorni/30 || 0} mes${giorni/30===1?"e":"i"} interi dalla fine del mese della fattura (es. fattura 26/05, 60 gg → 31/07).` : `data fattura + ${giorni} giorni, poi fine di quel mese.`} Controlla sempre l'accordo scritto con il cliente: alcune aziende usano conteggi diversi.
        </div>
      )}

      <button onClick={()=>{setCondizioneId("30gg");setDataFattura("");setGiorniCustom("30");setDffmCustom(false);}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
